import {
  Button,
  Emphasis,
  FormAction,
  FormField,
  FormGrid,
  FormNotice,
  FormRow,
  FormTitle,
} from "@lya-protect/lya-protect-form-library/dist/UI";
import "@src/Steps/simulate/landing/landing.scss";
import "./contactInfos.scss";
import {
  Form,
  InputButtonGroup,
  InputText,
  useFormConfig,
} from "@lya-protect/lya-protect-form-library/dist/FormAPI";
import { zod } from "@lya-protect/lya-protect-form-library/dist/Exports";
import { LoaderOverlay } from "@src/components/loaderOverlay/LoaderOverlay";
import { NavButton } from "@src/components/navButton/NavButton";
import { StepProps } from "../../step/Steps";

export type ContactInfosData = {
  civility?: "Monsieur" | "Madame";
  name?: string;
  surname?: string;
  mail?: string;
  acceptStorage?: boolean;
};
type ContactInfosProps = StepProps<ContactInfosData>;

const YOUSIGN_NAME_REGEX =
  /^[a-zA-Z0-9àáâãäåæçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ ß.’'()-]+$/;

const schema = zod.object({
  civility: zod.enum(["Monsieur", "Madame"], {
    required_error: "Champ requis",
  }),
  name: zod
    .string({ required_error: "Champ requis" })
    .min(1, { message: "Champ requis" })
    .max(95, "Nom trop long")
    .regex(YOUSIGN_NAME_REGEX, { message: "Nom invalide" }),
  surname: zod
    .string({ required_error: "Champ requis" })
    .min(1, { message: "Champ requis" })
    .max(95, "Prénom trop long")
    .regex(YOUSIGN_NAME_REGEX, { message: "Prénom invalide" }),
});

type FormValues = zod.infer<typeof schema>;

export function ContactInfos({ changeStep, data, setData }: ContactInfosProps) {
  const formConfig = useFormConfig<typeof schema, FormValues>({
    schema,
    defaultValues: data,
  });

  return (
    <>
      <LoaderOverlay
        isLoading={
          formConfig.formState.isSubmitting ||
          formConfig.formState.isSubmitSuccessful
        }
      />
      <div className="landing-step">
        <div className="stepper__centered-container landing-step__first-part">
          <div className="stepper__centered-content step__grid ">
            <NavButton
              onClick={() => {
                changeStep("TARIF", "backward");
              }}
            >
              Précédent
            </NavButton>
            <Form
              className="situation-step__form"
              formConfig={formConfig}
              onSubmit={(values) => {
                setData(values);
                changeStep("ADDRESS_INFOS", "forward");
              }}
            >
              <FormGrid>
                <FormTitle>
                  <h1>
                    Renseignez{" "}
                    <Emphasis>vos informations personnelles</Emphasis> pour
                    recevoir <Emphasis>votre devis</Emphasis>
                  </h1>
                </FormTitle>
                <FormNotice>
                  <Emphasis>*</Emphasis> Champs obligatoires
                </FormNotice>
                <FormRow>
                  <FormField>
                    <span className="contact-infos__form-label">
                      Civilité <Emphasis>*</Emphasis>
                    </span>
                    <InputButtonGroup<FormValues, string>
                      name="civility"
                      size="large"
                      variant="outline"
                      required
                      options={[
                        { label: "Monsieur", value: "Monsieur" },
                        { label: "Madame", value: "Madame" },
                      ]}
                    />
                  </FormField>
                </FormRow>
                <FormRow>
                  <FormField>
                    <InputText name="name" required label="Nom" />
                  </FormField>
                  <FormField>
                    <InputText name="surname" required label="Prénom" />
                  </FormField>
                </FormRow>
                <FormAction>
                  <Button
                    type="submit"
                    disabled={
                      !formConfig.formState.isValid ||
                      formConfig.formState.isSubmitting ||
                      formConfig.formState.isSubmitSuccessful
                    }
                  >
                    Suivant
                  </Button>
                </FormAction>
              </FormGrid>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}
